import {t} from 'i18next'
import {Button} from 'primereact/button'
import React from 'react'
import {useNavigate} from 'react-router-dom'

/**
 * The translation key will be translated within the button
 * @param {{label: string}} props
 * @returns {JSX.Element}
 * @constructor
 */
export const BackButton = (props: { translationKey: string, route?: string }) => {
	const navigate = useNavigate()

	return <div className={'w-full flex ml-auto'}><Button
		label={t<string>(props.translationKey)}
		icon={'fa-solid fa-reply pl-2'}
		iconPos={'left'}
		type={'button'}
		className={'ml-auto pl-0 pb-2 p-button-text'}
		onClick={() => props.route ? navigate(props.route) : navigate(-1)}
	/></div>
}